<form [formGroup]="runAppForm" (submit)="onSubmit()">
    <h4 mat-dialog-title>Essa ação criará/atualizará o aplicativo {{data.configuration.name}}, deseja continuar?</h4>
    <mat-dialog-content>

       <div *ngIf="data.configuration.hasAndroid() && data.configuration.hasIos()">
            <div class="form-check mb-2 d-flex align-items-center">
                <input formControlName="executeIos" class="me-1 form-check-input" type="checkbox" id="executeIos">
                <label class="form-check-label" for="executeIos">Executar Ios</label>
            </div>

            <div class="form-check mb-2 d-flex align-items-center">
                <input formControlName="executeAndroid" class="form-check-input me-1" type="checkbox" id="executeAndroid">
                <label class="form-check-label" for="executeAndroid">Executar Android</label>
            </div>
       </div>
       

        <div class="mb-2" *ngIf="runAppForm.controls['executeIos'].value">
            <label>Ios</label>
            <select formControlName="iosTrack" class="form-select">
                <option *ngFor="let track of iosTracks">{{ track }}</option>
            </select>
        </div>

        <div class="mb-2" *ngIf="runAppForm.controls['executeAndroid'].value">
            <label>Android</label>
            <select formControlName="androidTrack" class="form-select">
                <option *ngFor="let track of androidTracks">{{ track }}</option>
            </select>
        </div>

        <div class="mb-2">
            <label for="version-name">Version Name</label>
            <input formControlName="versionName" class="form-control" id="version-name" type="text">
        </div>

        <div *ngIf="!data.configuration?.versions?.versionCode" class="mb-2">
            <label for="version-code">Version Code</label>
            <input formControlName="versionCode" class="form-control" id="version-code" type="text">     
        </div>

        <div class="form-outline">
            <label class="form-label" for="release-notes">Release Notes</label>
            <textarea style="resize: none;" formControlName="releaseNotes" class="form-control" id="release-notes" rows="4"></textarea>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="d-flex justify-content-center gap-2">
            <button type="submit" class="btn btn-primary">Confirmar</button>
            <button type="button" (click)="close()" class="btn btn-danger">Cancelar</button>
        </div>
    </mat-dialog-actions>
</form>